module.exports = __webpack_public_path__ + "static/media/stacker-logo.32813f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stacker-logo.png
// module id = 1058
// module chunks = 3